import { createTheme } from '@uplight/up-design-components/theming';


const hostAppOverrides = {
  breakpoints: {
    values: {
      mobile: 375,
      tablet: 768,
      desktop: 1280,
    },
  },
};

const theme = createTheme(hostAppOverrides);

export default theme;
